import { yup } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"

export const validationSchema = (t) => yup.object().shape({
    file: yup.mixed().nullable(),
    filename: yup.string().when("file", (file, schema) =>
        file ? schema
            .required(t(I18N_NAMESPACE, "forms.documentAddForm.fileName.required"))
            .test("not-extension-only", t(I18N_NAMESPACE, "forms.documentAddForm.fileName.required"), (value) => value && !/^\.\w+$/.test(value.trim()))
            : schema.notRequired(),
    ),
    document_type: yup.string(),
    date: yup.date(),
    tags: yup.array(yup.string()),
})